var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconPig = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.193 15.298-.304-1.662L23 12.224a2.638 2.638 0 0 0-2.638 0C14.518 5.061 6.51 6.434 3.82 9.441c-1.57 1.688-.436 4.683-.251 5.646l1.32 3.957h1.318l.264-3.72c1.94 1.122 4.564.963 7.4.422l.251 1.98v1.318h1.32v-1.319l.342-2.07 2.19 1.384 2.005.172 1.161.224.765-1.029-.712-1.108z",
    fill: "#1A202C"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPig, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-pig.0a4d5c1c.svg";
export { ForwardRef as ReactComponent };